<template>
  <section>
    <div id="catering-image">
      <v-layout text-xs-center row wrap>
        <v-flex xs12>
          <v-img
            src="/static/custom-images/boda.jpeg"
            max-height="420"
            aspect-ratio="1.7"
          ></v-img>
        </v-flex>
      </v-layout>
    </div>
    <div id="catering">
      <v-layout text-xs-center xs12 sm6 offset-sm3 row wrap>
        <v-flex xs12 class="catering-text custom-title title pb-5 px-4">
          <p
            :style="
              restaurant.accent_color_font == undefined
                ? 'color:white;'
                : 'color:' + restaurant.accent_color_font + ';'
            "
            class="headline font-weight-bold"
          >
            {{ getTranslation("catering-title") }}
          </p>
          <p class="text-justify pt-3">{{ getTranslation("catering-desc") }}</p>
          <div class="text-left">
            <br />
            <p
              :style="
                restaurant.accent_color_font == undefined
                  ? 'color:white;'
                  : 'color:' + restaurant.accent_color_font + ';'
              "
              class="headline font-weight-bold"
            >
              Contactos:
            </p>
            <a
              :style="
                restaurant.accent_color_font == undefined
                  ? 'color:white;'
                  : 'color:' + restaurant.accent_color_font + ';'
              "
              href="tel:+34635714719"
              class="text-decoration-none"
            >
              <strong>Vicky:</strong> 635 714 719
            </a>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </section>
</template>


<script>
export default {
  props: ["restaurant"],
  name: "catering",
  methods: {
    // Get translation must be first if used in other methods
    getTranslation(key) {
      return this.$t(key);
    },
  },
};
</script>

<style scoped>
@import "custom_styles.css";

#catering {
  text-align: justify !important;
}
.catering-text {
  text-align: justify !important;
  line-height: 1.25 !important;
  max-width: max-content;
  padding-top: 48px;
  padding-left: 48px;
  padding-right: 48px;
  padding-bottom: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Catering.vue